/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, September 30th 2021, 8:39:13 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Grow from "@mui/material/Grow";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";

// eslint-disable-next-line
const GrowTransition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Grow ref={ref} {...props} />;
});

const SlideDownTransition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

interface FullScreenDialogProps extends Omit<React.HTMLProps<HTMLDivElement>, "title"> {
  title: React.ReactNode;
  save_text?: string;
  open: boolean;
  handleClose: any;
  handleSave?: React.MouseEventHandler;
  showAppBar?: boolean;
}

export default function FullScreenDialog({
  open,
  children,
  handleClose,
  handleSave,
  title,
  save_text,
  showAppBar = true,
  className,
}: FullScreenDialogProps) {
  return (
    <Dialog
      className={className ?? "os-fullscreen-dialog"}
      fullScreen
      fullWidth
      maxWidth="xl"
      open={open}
      onClose={handleClose}
      TransitionComponent={SlideDownTransition}
    >
      {showAppBar ? (
        <AppBar className="os-fullscreen-appbar" sx={{ position: "fixed" }}>
          <Toolbar>
            <img className="os-fullscreen-dialog-logo" src="/img/onestop-symbol-in-circle-white.svg" alt="OneStop" />
            <Typography className="os-fullscreen-title" sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {title}
            </Typography>
            {save_text ? (
              <Button className="os-fullscreen-next" autoFocus color="inherit" onClick={handleSave} variant="text">
                {save_text}
              </Button>
            ) : null}
            <IconButton
              className="os-fullscreen-close"
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      ) : null}
      {children}
    </Dialog>
  );
}
